import React, { useState, useEffect, Children, cloneElement, isValidElement } from 'react';
import { useInView } from '@cian/valuation-utils-component';

interface IOffersListLazyWrapperProps {
  children: React.ReactNode;
  // Необязательно: можно добавить пропсы для настройки IntersectionObserver, например threshold, rootMargin и т.д.
  // threshold?: number;
  // rootMargin?: string;
}

export const OffersListLazyWrapper: React.FC<IOffersListLazyWrapperProps> = ({
  children /*, threshold = 0, rootMargin = '0px' */,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0, // Значение по умолчанию для threshold
    triggerOnce: true, // Загружать только один раз
    // rootMargin,
  });

  useEffect(() => {
    if (inView) {
      setIsVisible(true);
    }
  }, [inView]);

  // Ожидаем только одного потомка (OffersList), но делаем проверку на всякий случай
  const child = Children.only(children);

  if (!isValidElement(child)) {
    // Если потомок не является валидным React-элементом (GrapesJS не должен допустить это)
    console.error('OffersListLazyWrapper ожидает единственного валидного React-элемента в качестве потомка.');

    return null;
  }

  // Клонируем потомка (OffersList) и передаём ему проп shouldLoad
  // ref вешаем на внешний div
  return <div ref={ref}>{cloneElement(child as React.ReactElement, { shouldLoad: isVisible })}</div>;
};
